import { useState, useEffect } from 'react';
import { Stack, Text, Loader, Card, ThemeIcon, Divider, Group, Title } from '@/components/ui';
import { IconBrain } from '@tabler/icons-react';

export default function ProcessingStatus() {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setElapsed((prev) => prev + 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return mins > 0 ? `${mins}m ${secs}s` : `${secs}s`;
  };

  return (
    <Card shadow="sm" padding="lg" radius="md" withBorder>
      <Group justify="space-between" mb="sm">
        <Group gap="xs">
          <IconBrain size={20} />
          <Title order={4}>AI Processing</Title>
        </Group>
      </Group>
      <Divider mb="sm" />
      <Stack align="center" gap="lg" py="xl">
        <ThemeIcon size={64} radius="xl" color="violet" variant="light">
          <Loader size="lg" loaderVariant="dots" color="violet" />
        </ThemeIcon>
        <div style={{ textAlign: 'center' }}>
          <Text fw={500} size="lg">Processing your input...</Text>
          <Text size="sm" c="dimmed" mt="xs">
            The AI is extracting and structuring data from your input.
          </Text>
          <Text size="sm" c="dimmed" mt="xs">
            Elapsed: {formatTime(elapsed)}
          </Text>
        </div>
      </Stack>
    </Card>
  );
}
